import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitApplication = (data) =>
  axios.post(`${API}/applications`, data).then((r) => r.data);

export const subscribe = (email, language) =>
  axios.post(`${API}/subscribe`, { email, language }).then((r) => r.data);
